module.exports = __webpack_public_path__ + "static/media/red_panel.e3109fda.svg";